import { render, staticRenderFns } from "./StartupPlate.vue?vue&type=template&id=5be62a58&scoped=true&"
import script from "./StartupPlate.vue?vue&type=script&lang=js&"
export * from "./StartupPlate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be62a58",
  null
  
)

export default component.exports